var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _path, _rect, _rect2, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_623:4347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 224C50.1441 224 0 173.856 0 112C0 50.1441 50.1441 0 112 0C173.856 0 224 50.1441 224 112C224 173.856 173.856 224 112 224Z",
    fill: "url(#paint0_radial_623:4347)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddii_623:4347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.621 204.002C62.5342 204.002 21.1201 162.588 21.1201 111.501C21.1201 60.4141 62.5342 19 113.621 19C164.708 19 206.122 60.4141 206.122 111.501C206.122 162.588 164.708 204.002 113.621 204.002Z",
    fill: "url(#paint1_radial_623:4347)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_623:4347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.892 39.1914C112.772 39.1914 114.258 40.7253 114.258 42.5659V47.5182C114.258 49.4026 112.728 50.8927 110.892 50.8927C109.012 50.8927 107.526 49.3588 107.526 47.5182V42.6098C107.526 40.7253 109.012 39.1914 110.892 39.1914Z",
    fill: "url(#paint2_linear_623:4347)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_623:4347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9041 60.4509L68.4012 63.9569C69.7126 65.2717 69.7126 67.4191 68.4012 68.7338C67.7455 69.3912 66.8712 69.7418 65.9969 69.7418C65.1226 69.7418 64.2484 69.3912 63.5926 68.7338L60.0955 65.2278C58.7841 63.9131 58.7841 61.7657 60.0955 60.4509C61.4069 59.1362 63.5489 59.1362 64.9041 60.4509Z",
    fill: "url(#paint3_linear_623:4347)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_623:4347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5661 108.086H47.506C49.3858 108.086 50.8721 109.62 50.8721 111.46C50.8721 113.345 49.342 114.835 47.506 114.835H42.5661C40.6863 114.835 39.2 113.301 39.2 111.46C39.2 109.62 40.6863 108.086 42.5661 108.086Z",
    fill: "url(#paint4_linear_623:4347)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_623:4347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.8539 154.056C65.1654 152.742 67.3075 152.742 68.6189 154.056C69.9304 155.371 69.9304 157.519 68.6189 158.833L65.1217 162.339C64.4659 162.997 63.5916 163.347 62.7173 163.347C61.843 163.347 60.9687 162.997 60.3129 162.339C59.0015 161.025 59.0015 158.877 60.3129 157.562L63.8539 154.056Z",
    fill: "url(#paint5_linear_623:4347)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_623:4347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.243 171.629C113.123 171.629 114.609 173.163 114.609 175.003V179.956C114.609 181.84 113.079 183.33 111.243 183.33C109.407 183.33 107.877 181.796 107.877 179.956V175.003C107.877 173.119 109.407 171.629 111.243 171.629Z",
    fill: "url(#paint6_linear_623:4347)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_623:4347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.543 153.795L162.04 157.301C163.351 158.615 163.351 160.763 162.04 162.078C161.384 162.735 160.51 163.086 159.636 163.086C158.761 163.086 157.887 162.735 157.231 162.078L153.734 158.572C152.423 157.257 152.423 155.109 153.734 153.795C155.089 152.48 157.231 152.48 158.543 153.795Z",
    fill: "url(#paint7_linear_623:4347)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii_623:4347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.628 107.73H179.568C181.447 107.73 182.934 109.264 182.934 111.105C182.934 112.989 181.404 114.48 179.568 114.48H174.628C172.748 114.48 171.262 112.946 171.262 111.105C171.262 109.221 172.748 107.73 174.628 107.73Z",
    fill: "url(#paint8_linear_623:4347)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ii_623:4347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.008 60.1853C158.32 58.8705 160.462 58.8705 161.773 60.1853C163.085 61.5 163.085 63.6475 161.773 64.9622L158.276 68.4682C157.62 69.1256 156.746 69.4762 155.872 69.4762C154.998 69.4762 154.123 69.1256 153.468 68.4682C152.156 67.1535 152.156 65.006 153.468 63.6913L157.008 60.1853Z",
    fill: "url(#paint9_linear_623:4347)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_dii_623:4347)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.2336,
    height: 8.14659,
    rx: 4.07329,
    transform: "matrix(0.6498 -0.759901 0.7605 0.649578 107.168 109.734)",
    fill: "url(#paint10_linear_623:4347)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_dii_623:4347)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.91229,
    ry: 9.90443,
    transform: "matrix(0.988643 0.150282 -0.149939 0.988695 110.94 111.341)",
    fill: "#393E42"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_dii_623:4347)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.05751,
    ry: 6.05271,
    transform: "matrix(0.988643 0.150282 -0.149939 0.988695 110.941 111.34)",
    fill: "#393E42"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_623:4347",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 224,
    height: 224
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 224C50.1441 224 0 173.856 0 112C0 50.1441 50.1441 0 112 0C173.856 0 224 50.1441 224 112C224 173.856 173.856 224 112 224Z",
    fill: "#3BBFBE"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_623:4347)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.45
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61.3527,
    height: 91.5571,
    transform: "matrix(-0.795979 0.605325 0.605325 0.795979 84.3037 -23.6016)",
    fill: "url(#paint11_linear_623:4347)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.4
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19.8216,
    height: 285.998,
    transform: "matrix(-0.795979 0.605325 0.605325 0.795979 -4.4209 -26.4336)",
    fill: "url(#paint12_linear_623:4347)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.60721,
    height: 250.13,
    transform: "matrix(-0.795979 0.605325 0.605325 0.795979 -30.8506 -25.4883)",
    fill: "url(#paint13_linear_623:4347)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_623:4347",
    x: -3,
    y: -2,
    width: 232.007,
    height: 231.007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 5.00694
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.50347
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.496 0 0 0 0 0.944 0 0 0 0 0.936945 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0638021 0 0 0 0 0.321137 0 0 0 0 0.344531 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_623:4347",
    result: "effect2_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddii_623:4347",
    x: 11.1132,
    y: 10.2749,
    width: 203.734,
    height: 200.398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.00694,
    dy: 1.66898
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.820799 0 0 0 0 0.962535 0 0 0 0 0.960303 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.66898,
    dy: -1.66898
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.52806
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.869253 0 0 0 0 0.98908 0 0 0 0 0.987193 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_623:4347",
    result: "effect2_dropShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_623:4347",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0027917 0 0 0 0 0.555542 0 0 0 0 0.546837 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 1.66898
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.52806
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0037778 0 0 0 0 0.529556 0 0 0 0 0.519246 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_623:4347",
    result: "effect4_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_623:4347",
    x: 105.856,
    y: 35.8534,
    width: 10.0704,
    height: 18.3791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.66898,
    dy: 3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.66898,
    dy: -3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_623:4347",
    result: "effect2_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_623:4347",
    x: 57.4433,
    y: 56.1269,
    width: 13.6104,
    height: 16.9533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.66898,
    dy: 3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.66898,
    dy: -3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_623:4347",
    result: "effect2_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_623:4347",
    x: 37.5312,
    y: 104.748,
    width: 15.0098,
    height: 13.4259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.66898,
    dy: 3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.66898,
    dy: -3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_623:4347",
    result: "effect2_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_623:4347",
    x: 57.6601,
    y: 149.732,
    width: 13.6114,
    height: 16.9533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.66898,
    dy: 3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.66898,
    dy: -3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_623:4347",
    result: "effect2_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_623:4347",
    x: 106.208,
    y: 168.291,
    width: 10.0704,
    height: 18.3791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.66898,
    dy: 3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.66898,
    dy: -3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_623:4347",
    result: "effect2_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_623:4347",
    x: 151.082,
    y: 149.471,
    width: 13.6104,
    height: 16.9533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.66898,
    dy: 3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.66898,
    dy: -3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_623:4347",
    result: "effect2_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_623:4347",
    x: 169.593,
    y: 104.393,
    width: 15.0098,
    height: 13.4259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.66898,
    dy: 3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.66898,
    dy: -3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_623:4347",
    result: "effect2_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ii_623:4347",
    x: 150.815,
    y: 55.8613,
    width: 13.6104,
    height: 16.9533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.66898,
    dy: 3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.66898,
    dy: -3.33796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_623:4347",
    result: "effect2_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_dii_623:4347",
    x: 108.457,
    y: 73.6081,
    width: 42.3046,
    height: 44.6968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.94944,
    dy: 1.5229
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.71327
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14025 0 0 0 0 0.253442 0 0 0 0 0.28475 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_623:4347",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.380726,
    dy: 0.380726
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.380726,
    dy: -0.380726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.190363
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_623:4347",
    result: "effect3_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_dii_623:4347",
    x: 100.512,
    y: 98.8606,
    width: 31.662,
    height: 29.0754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.68984,
    dy: 2.05841
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.31571
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_623:4347",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.514603
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.02921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.257302
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_623:4347",
    result: "effect3_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_dii_623:4347",
    x: 104.883,
    y: 104.771,
    width: 13.1444,
    height: 13.6532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.514603,
    dy: 0.514603
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.257302
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_623:4347",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.514603,
    dy: 0.514603
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_623:4347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.514603,
    dy: -1.54381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.257302
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_623:4347",
    result: "effect3_innerShadow_623:4347"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_623:4347",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112 112) rotate(94.2538) scale(121.334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.943838,
    stopColor: "#43C6C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_623:4347",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.621 111.501) rotate(90) scale(92.501)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#FBFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#D8F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623:4347",
    x1: 110.892,
    y1: 39.1914,
    x2: 110.892,
    y2: 50.8927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A444A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_623:4347",
    x1: 64.2484,
    y1: 59.4648,
    x2: 64.2484,
    y2: 69.7418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A444A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_623:4347",
    x1: 45.036,
    y1: 108.086,
    x2: 45.036,
    y2: 114.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A444A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_623:4347",
    x1: 64.4659,
    y1: 153.07,
    x2: 64.4659,
    y2: 163.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A444A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_623:4347",
    x1: 111.243,
    y1: 171.629,
    x2: 111.243,
    y2: 183.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A444A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_623:4347",
    x1: 157.887,
    y1: 152.809,
    x2: 157.887,
    y2: 163.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A444A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_623:4347",
    x1: 177.098,
    y1: 107.73,
    x2: 177.098,
    y2: 114.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A444A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_623:4347",
    x1: 157.62,
    y1: 59.1992,
    x2: 157.62,
    y2: 69.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A444A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_623:4347",
    x1: 23.6168,
    y1: 0,
    x2: 23.6168,
    y2: 8.14659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E575E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343B41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_623:4347",
    x1: 30.6763,
    y1: 0,
    x2: 30.6763,
    y2: 91.5571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_623:4347",
    x1: 9.91082,
    y1: 0,
    x2: 9.91082,
    y2: 285.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_623:4347",
    x1: 3.30361,
    y1: 0,
    x2: 3.30361,
    y2: 250.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon_clock.01542c548c35ddb98effe85c7a8ce07c.svg";
export { ForwardRef as ReactComponent };